import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const STATUS_LABELS = {
    interesado: "Muy interesados",
    posible_cierre: "Posible cierre en 7 días",
    ganado: "Ganados",
    perdido: "Perdidos",
};

export const STATUS_COLORS = {
    interesado: "#002FA7",
    posible_cierre: "#FF9900",
    ganado: "#008F11",
    perdido: "#D32F2F",
};

export const formatMoney = (n) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    }).format(Number(n || 0));

// Backwards compat alias (was formatEuro)
export const formatEuro = formatMoney;

const SPANISH_MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export const formatArrivalDate = (iso) => {
    if (!iso) return null;
    const [y, m, d] = iso.split("-").map((s) => parseInt(s, 10));
    if (!y || !m || !d) return null;
    const month = SPANISH_MONTHS[m - 1];
    const currentYear = new Date().getFullYear();
    return y === currentYear ? `${d} ${month}` : `${d} ${month} ${y}`;
};
